<div class="card my-2">
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-md-10">
        <h4>{{ program.name }}</h4>
        <h6 class="text-muted">{{ program.clinic.longName }}</h6>
        <!-- <div class="d-flex align-items-center gap-2">
          <div class="d-none d-md-block">
            <span class="fs-6 small">{{ "ratingText" | transloco }}</span>
          </div>
          <div class="text-warning">
            @for (star of stars; track $index;) {
            <i
              class="bi"
              [ngClass]="{
                'bi-star-fill': $index < filledStars,
                'bi-star-half': $index === filledStars && isHalfStar,
                'bi-star': $index >= filledStars && !isHalfStar
              }"
            ></i>
            }
          </div>
        </div> -->
        <div class="row mt-3">
          <div
            class="col-12 col-md-3 my-2 my-0-md"
            (click)="$event.stopPropagation()"
          >
            <app-dot-slider [images]="images" [dots]="getDotsCount()">
            </app-dot-slider>
          </div>
          <ng-content #info></ng-content>
        </div>
      </div>
      <div
        class="col-12 col-md-2 d-flex flex-md-column flex-row-reverse justify-content-between align-items-end mt-3 mt-md-0"
      >
        <button
          class="btn btn-outline-danger"
          (click)="
            delete.emit({
              type: type,
              program: program
            })
          "
        >
          {{ "delete" | transloco }}
        </button>
        <!-- <div>
          <div>
            <i class="bi bi-star-fill text-warning"></i>
            <span class="ms-2">{{ rate }} / 10</span>
          </div>
          <div class="text-muted">{{ "reviews" | transloco }}</div>
        </div> -->
        <div class="text-end-md">
          @if(!program.discount){
          <div class="d-flex justify-content-end align-items-center">
            <span class="text-decoration-line-through me-2"
              >UAH {{ originalPrice | formattedPrice }}</span
            >
            <button
              class="btn"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="{{ 'full_price' | transloco }} UAH {{
                originalPrice | formattedPrice
              }}
					  {{ 'discount_amount' | transloco }} – UAH {{
                discountAmount | formattedPrice
              }}
					  {{ 'final_price' | transloco }} UAH {{ discountedPrice | formattedPrice }}"
            >
              <i class="bi bi-info-circle"></i>
            </button>
          </div>
          }
          <span class="h4">UAH {{ program.price | formattedPrice }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer py-0 bg-body">
    <app-program-tabs [program]="program" [teamPath]="teamPath">
    </app-program-tabs>
  </div>
</div>
